/* eslint-disable prettier/prettier */
import { apiUrls } from '@http/api-urls'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { NextPageFC } from '@shared/models/next-fc'
import { httpAdminService } from 'admin/http'
import { PageConfig } from 'admin/types'
import { GetServerSideProps } from 'next'
import { Sitemap } from 'screens/sitemap'

const SitemapPage: NextPageFC<{ pagesFromAdminPanel: PageConfig[] }, PageLayoutOwnProps> = ({
	pagesFromAdminPanel,
}) => Sitemap({ pagesFromAdminPanel })

SitemapPage.layout = PageLayout

SitemapPage.headProps = {
	title: 'Карта сайта',
	description: 'Перечень всех страниц сайта. Credit.Club.',
}

export const getServerSideProps: GetServerSideProps = async () => {
	const pagesFromAdminPanel: PageConfig = await httpAdminService.get(apiUrls.getAdminPages())

	return { props: { pagesFromAdminPanel } }
}

export default SitemapPage
